import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useEffect } from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';
import { CloseRounded } from '@/components/Icons/CloseRounded';
import { AnalyticsEvent, useAnalytics } from '@/hooks/useAnalytics';
import { useController } from '@/hooks/useController';
import { useWidgetState } from '@/hooks/useWidgetState';
import { autoDisplayWelcomeMessageSelector, isLeftAlignedSelector, isTopAlignedSelector, welcomeMessageSelector, } from '@/state/config';
import { isWidgetOpenState, openingMessageState } from '@/state/session';
export const OpeningMessage = () => {
    const { trackEvent } = useAnalytics();
    const welcomeMessage = useRecoilValue(welcomeMessageSelector);
    const [showOpeningMessage, setShowOpeningMessage] = useRecoilState(openingMessageState);
    const open = useRecoilValue(isWidgetOpenState);
    const { closeWidget } = useWidgetState();
    const { notifyOpeningMessageClosed } = useController();
    const isLeft = useRecoilValue(isLeftAlignedSelector);
    const isTop = useRecoilValue(isTopAlignedSelector);
    const autoDisplayWelcomeMessage = useRecoilValue(autoDisplayWelcomeMessageSelector);
    // Auto-display opening message on init (null when manual_teaser_mode is enabled)
    useEffect(() => {
        setShowOpeningMessage(!!autoDisplayWelcomeMessage);
    }, [setShowOpeningMessage, autoDisplayWelcomeMessage]);
    useEffect(() => {
        if (open && showOpeningMessage) {
            setShowOpeningMessage(false);
        }
    }, [open, setShowOpeningMessage, showOpeningMessage]);
    const handleClose = useCallback(() => {
        trackEvent(AnalyticsEvent.CloseOpeningMessageClick);
        setShowOpeningMessage(false);
        closeWidget();
        notifyOpeningMessageClosed();
    }, [
        closeWidget,
        notifyOpeningMessageClosed,
        setShowOpeningMessage,
        trackEvent,
    ]);
    const handleKeyDown = useCallback(async (event) => {
        if (event.key === 'Enter') {
            handleClose();
        }
    }, [handleClose]);
    if (!showOpeningMessage) {
        return null;
    }
    return (_jsxs("div", { className: cn('shadow-bubble relative mb-1 ml-auto box-border flex w-max max-w-[200px] animate-fade-in cursor-default rounded-sm p-2 px-3 text-sm', 'bg-(--color-opening-message-background,var(--color-accent))', {
            'rounded-l-lg': !isLeft,
            'rounded-r-lg': isLeft,
        }), children: [_jsx("p", { className: "text-(--color-opening-message-foreground,var(--color-text-primary-foreground)) m-0", children: welcomeMessage }), _jsx("span", { role: "button", tabIndex: 0, className: cn('shadow-bubble absolute -right-2 flex h-5 w-5 cursor-pointer items-center justify-center rounded-full bg-background p-1', isTop ? '-bottom-3' : '-top-3', {
                    '-left-2': isLeft,
                }), onClick: handleClose, onKeyDown: handleKeyDown, children: _jsx(CloseRounded, { color: "var(--color-opening-message-foreground, var(--color-accent))" }) })] }));
};
